import React from 'react';
import { TIGHT_FIT_PARAM } from 'constants/System';

const ListRowFavourite = ({ width, starred, onClick }) => {
    return <React.Fragment>
        <div className="col-auto px-1 actions d-sm-flex">
            <span className="icon-btn" style={{ width: width > TIGHT_FIT_PARAM ? 48 : 18 }} onClick={onClick}>
                {starred ? <i className="zmdi zmdi-star" /> : <i className="zmdi zmdi-star-outline" />}
            </span>
        </div>
    </React.Fragment>;
};

export default ListRowFavourite;


// WEBPACK FOOTER //
// ./components/ListRowFavourite/index.js